// @flow
import React from 'react';
import LazyLoad from 'react-lazyload';

import '../../../static/scss/components/media.scss';

export type Props = {
  modifier?: string,
  iconImage?: any,
  children?: any,
  image?: string,
  mobileImage?: string | boolean,
  title?: any,
  webp?: boolean
};

const Media = ({
  modifier = null,
  iconImage = false,
  children = false,
  image = false,
  mobileImage = false,
  title = false,
  webp = false
}: Props) => {
  const baseClassName = 'c-media';
  let className = baseClassName;

  if (modifier) {
    if (modifier.constructor === Array) {
      className = modifier.map(mod => `${className} ${baseClassName}--${mod}`);
    } else {
      className += ` ${baseClassName}--${modifier}`;
    }
  }

  let body;

  if (typeof children === 'string') {
    body = <p className="c-media-body">{children}</p>;
  } else if (React.isValidElement(children)) {
    const child = React.Children.only(children);
    body = React.cloneElement(child, {
      ...child.props,
      className: 'c-media-body'
    });
  }

  return (
    <div className={className}>
      {iconImage && (
        <LazyLoad once offset={100} height={0}>
          <figure className={`${baseClassName}-figure`}>
            <img className="c-media__img--desktop" src={image} alt={title} />
            <img
              className="c-media__img--mobile"
              src={mobileImage}
              alt={title}
            />
          </figure>
        </LazyLoad>
      )}
      {!iconImage && (
        <LazyLoad once offset={100} height={0}>
          <picture>
            {webp && (
              <source srcSet={image.replace('png', 'webp')} type="image/webp" />
            )}
            <source srcSet={image} type="image/png" />
            <img
              className={`${baseClassName}-figure`}
              src={image}
              alt={title}
            />
          </picture>
        </LazyLoad>
      )}
      {title && <h3 className={`${baseClassName}-title`}>{title}</h3>}
      {body}
    </div>
  );
};

export default Media;
